import { NavLink } from "react-router-dom";

import { NAV, ACCOUNT_NAV } from "../../lib/site";
import { useAuth } from "../../hooks/useAuth";

/**
 * CS-2 (owner D-1, 2026-09-27) — the portal's main navigation on desktop and tablet (business/19 §6/§76).
 *
 *   ≥ 992px   a sidebar with labels
 *   768–991   a collapsible sidebar: an icon rail by default, expanded with the toggle (labels stay readable
 *             to screen readers when collapsed — they are visually hidden, never removed)
 *   < 768     not rendered: the phone uses the bottom bar and its "More" drawer (MobileNav)
 *
 * The rows are business/20 §44's, declared once in lib/site.js.
 */
export default function Sidebar({ expanded, onToggle, onNavigate }) {
  const { signOut } = useAuth();
  const link = (item) => (
    <NavLink
      key={item.to}
      to={item.to}
      end={item.to === "/"}
      onClick={onNavigate}
      title={item.label}
      className={({ isActive }) => `vp-sidelink${isActive ? " active" : ""}`}
    >
      <i className={`bi ${item.icon}`} aria-hidden="true" />
      <span className="vp-sidelabel">{item.label}</span>
    </NavLink>
  );
  return (
    <nav id="vp-sidebar" className={`vp-sidebar d-none d-md-flex${expanded ? " is-expanded" : ""}`} aria-label="Main">
      <button type="button" className="vp-sidetoggle btn btn-sm btn-light d-none d-md-inline-flex d-lg-none mb-2"
        onClick={onToggle} aria-expanded={expanded} aria-controls="vp-sidebar">
        <i className={`bi ${expanded ? "bi-chevron-double-left" : "bi-chevron-double-right"}`} aria-hidden="true" />
        <span className="visually-hidden">{expanded ? "Collapse menu" : "Expand menu"}</span>
      </button>
      {NAV.map(link)}
      <hr className="my-2" />
      {ACCOUNT_NAV.map(link)}
      <button type="button" className="vp-sidelink btn btn-link text-start" onClick={signOut} title="Logout">
        <i className="bi bi-box-arrow-right" aria-hidden="true" />
        <span className="vp-sidelabel">Logout</span>
      </button>
    </nav>
  );
}
